// extracted by mini-css-extract-plugin
export default {"root":"ModifyContent_root__rMLUT","placeHolderShimmer":"ModifyContent_placeHolderShimmer__zBpbH"};